"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_padlock__open__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "21e558ed-6ba4-41b2-8a9d-586f90336edd",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192.02 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "524e36c5-219f-4248-8a73-741fd716577d",
    x1: 90.95,
    y1: 120.85,
    x2: 148.36,
    y2: 178.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "padlock-open-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "5e868bdf-c917-4ab1-a353-4bf033873b05",
    "data-name": "Security_ic_hi 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,76H64V48.55C64,35.12,53,23.78,39.59,24A24,24,0,0,0,16,48V64a4,4,0,0,1-4,4h0a4,4,0,0,1-4-4V48.64C8,30.73,22.65,15.7,40.55,16A32,32,0,0,1,72,48Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64,46a24,24,0,0,0-48,0v2a24,24,0,0,1,48,0Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "d24795c5-f781-4e74-adc3-6a9be269be88",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.83,
    y: 72,
    width: 128.17,
    height: 104,
    rx: 16,
    ry: 16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.02,
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,174H47.83a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H144a16,16,0,0,0,16-16v-2A16,16,0,0,1,144,174Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,107.36a9.8,9.8,0,0,1,9.75,8.7c0-.3.06-.59.06-.89a9.81,9.81,0,0,0-19.62,0,8.89,8.89,0,0,0,.07.89A9.8,9.8,0,0,1,96,107.36Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,105.36a9.81,9.81,0,0,1,4,18.76V148a4,4,0,0,1-8,0V124.12a9.81,9.81,0,0,1,4-18.76m0-4a13.81,13.81,0,0,0-8,25.06V148a8,8,0,0,0,16,0V126.42a13.81,13.81,0,0,0-8-25.06Z",
    transform: "translate(0 0)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.83,115.17a9.81,9.81,0,1,0-13.81,9V148a4,4,0,0,0,8,0V124.12A9.79,9.79,0,0,0,105.83,115.17Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,105.36a9.81,9.81,0,0,1,4,18.76V148a4,4,0,0,1-8,0V124.12a9.81,9.81,0,0,1,4-18.76m0-4a13.81,13.81,0,0,0-8,25.06V148a8,8,0,0,0,16,0V126.42a13.81,13.81,0,0,0-8-25.06Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.07,105.73a13.77,13.77,0,0,1-2,20.69V148a8,8,0,0,1-8,8,7.86,7.86,0,0,1-3.7-.92L114,176h30a16,16,0,0,0,16-16v-3Z",
    transform: "translate(0 0)",
    fill: "url(#524e36c5-219f-4248-8a73-741fd716577d)"
  }))));
}

var _default = ic_padlock__open__dark;
exports.default = _default;